/*
 * Public API Surface of pepperi-lib/select
 */
export * from './select.module';
export * from './select.component';
